"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderAITranslatedTooltip = RenderAITranslatedTooltip;
const jsx_runtime_1 = require("react/jsx-runtime");
const Tooltip_1 = require("Views/Shared/Components/Tooltip");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const app_1 = require("app");
const AiTranslatedTooltip = ({ tooltipText }) => {
    return ((0, jsx_runtime_1.jsx)(Tooltip_1.default, { isPortalRendering: true, className: "leading-[1] block", content: tooltipText, isDisabled: false, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "info-outline", className: "fill-df-gray-text icon-l", "aria-label": tooltipText }) }));
};
function RenderAITranslatedTooltip(data, element) {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(AiTranslatedTooltip, Object.assign({}, data)), element);
}
